import { IDisplayableUserProfile } from 'fitbeat.gym-core';
import { combineReducers } from 'redux';
import * as types from '../actionTypes';

export interface IOpenInviteModel {
  isLoadingClassList: boolean;
  classListError: string | null;
  openInviteUserProfiles: IDisplayableUserProfile[];
}

export interface IOpenInviteDetails {
  openInviteClassesByWorkoutId: { [Key: number]: IOpenInviteModel };
}

export const bookingInitialState = {
  openInviteClassesByWorkoutId: {},
};

const openInviteClassesByWorkoutId = (state: IOpenInviteDetails = bookingInitialState, action): IOpenInviteDetails => {
  switch (action.type) {
    case types.GET_CLASS_LIST_REQUEST: {
      const { workoutId, hideLoader } = action.payload;
      const currentOpenInviteDetails: IOpenInviteModel | undefined = state[workoutId];
      const userProfiles = currentOpenInviteDetails ? currentOpenInviteDetails.openInviteUserProfiles : [];
      return {
        ...state,
        [workoutId]: {
          classListError: null,
          isLoadingClassList: !hideLoader,
          openInviteUserProfiles: hideLoader ? userProfiles : [],
        },
      };
    }
    case types.GET_CLASS_LIST_SUCCESS: {
      const { workoutId, openInviteUserProfiles } = action.payload;
      return {
        ...state,
        [workoutId]: {
          classListError: null,
          isLoadingClassList: false,
          openInviteUserProfiles,
        },
      };
    }
    case types.GET_CLASS_LIST_FAILURE: {
      const { workoutId, error } = action.payload;
      return {
        ...state,
        [workoutId]: {
          classListError: error,
          isLoadingClassList: false,
          openInviteUserProfiles: [],
        },
      };
    }
    default:
      return state;
  }
};

export const bookings = combineReducers({
  openInviteClassesByWorkoutId,
});
